export default __webpack_public_path__ + "static/media/previous_expo_2019 (3).d843cf9c.jpg";